import React, { useEffect, useState } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { FarmOperation_getMasters, SubCropMasterAdd, SubCropMasterGet, } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import Select from "react-select";
import { formatRoleName, modalCustomStyles } from "../Utilities/utils";

export const SubCropMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [name, setName] = useState()
    const [status, setStatus] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [error, setError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)
    const [getCrop, setGetCrop] = useState([])
    const [cropName, setCropName] = useState()
    const [cropError, setCropError] = useState('')

    const getData = async () => {
        const URL = SubCropMasterGet;
        try {
            setLoader(true)
            const response = await axios.get(URL)
            setData(response.data.response)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }

    const geCroptMaster = async () => {
        const apiUrl = FarmOperation_getMasters;
        const headers = await GetApiHeaders();
        try {
            const response = await axios.get(apiUrl, { headers })
            setGetCrop(response.data.response.Crop)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getData()
        geCroptMaster()
    }, [])

    const headersData = [
        {
            field: "cropId.name",
            header: "Crop ",
        },
        {
            field: "name",
            header: "SubCrop ",
        },
        {
            field: "createdBy.firstName",
            header: "Created By",
        },
        {
            field: "status",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {
        console.log(data, 'data');

        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setCropName(data.cropId.id)
        setName(data.name)
        setStatus(data.status)
        setError('')
        setStatusError('')
        setCropError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setName('')
        setStatus('')
        setCropName('')
        setError('')
        setStatusError('')
        setCropError('')
    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    const handleName = (e) => {
        const input = e.target.value;
        const formattedInput = formatRoleName(input);
        setName(formattedInput);
        if (input) {
            setError('')
        }
    }


    const handleStatus = (e) => {
        const statusInput = e.target.value
        setStatus(statusInput)
        if (statusInput) {
            setStatusError('')
        }
    }

    const handleCropName = (e) => {
        const input = e.target.value
        setCropName(input)
        if (input) {
            setCropError('')
        }
    }

    const handleSubmitData = async () => {
        if (!status) {
            setStatusError("Select Status")
        }

        if (!name) {
            setError('Enter SubCrop Name')
        }
        if (!cropName) {
            setCropError('Select Crop Name')
        }
        const apiUrl = SubCropMasterAdd;
        const reqData = {
            id: saveEdit === "Submit" ? 0 : id,
            name: name,
            status: status,
            cropId: cropName
        }
        const headers = await GetApiHeaders()
        try {
            if (name !== '' && status !== '' && cropName !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.message);
                    setLoader(false)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">  Master</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text"> SubCrop Master</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Add SubCrop Master"  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon mr-1" />
                                                    Add
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                            FileName={'SubCrop'}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'SubCrop Master'}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={
                                                <div>
                                                    <div className='row'>
                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="cropDropdown"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                Crop <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="cropDropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Crop Name"
                                                                isClearable
                                                                value={
                                                                    getCrop
                                                                        .map((item) => ({
                                                                            value: item.id,
                                                                            label: item.name,
                                                                        }))
                                                                        .find((option) => String(option.value) === String(cropName)) || null
                                                                }
                                                                options={getCrop.map((item) => ({
                                                                    value: item.id,
                                                                    label: item.name,
                                                                }))}
                                                                onChange={(selectedOption) =>
                                                                    handleCropName({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                            />

                                                            <span style={{ color: "red" }}>
                                                                {cropError}
                                                            </span>
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="subCrop"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                SubCrop <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <input
                                                                id="subCrop"
                                                                type="text"
                                                                className="form-control"
                                                                maxLength={30}
                                                                placeholder="Enter SubCrop Name"
                                                                value={name}
                                                                onChange={handleName}
                                                                style={{
                                                                    height: "42px",
                                                                    borderRadius: "4px",
                                                                    border: "1px solid #ced4da",
                                                                    padding: "0 12px",
                                                                    fontSize: "14px",
                                                                    width: "100%",
                                                                }}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = "#C9E4B4";
                                                                    e.target.style.boxShadow = "0 0 0 1px #C9E4B4";
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = "#ced4da";
                                                                    e.target.style.boxShadow = "none";
                                                                }}
                                                            />

                                                            <span style={{ color: "red" }}>{error}</span>
                                                        </div>

                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="statusDropdown"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                Status <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="statusDropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Status"
                                                                isClearable
                                                                value={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ].find((option) => option.value === status) || null}
                                                                options={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ]}
                                                                onChange={(selectedOption) =>
                                                                    handleStatus({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                            <span style={{ color: "red" }}>
                                                                {statusError}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'SubCrop Master'}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}